import { ModalType } from './Modal'

const slide = (x: number, y: number) => ({
  from: { x, y, scale: 1, opacity: 1 },
  enter: { x: 0, y: 0, scale: 1, opacity: 1 },
  leave: { x, y, scale: 1, opacity: 1 },
})

/** Numeric phases so an open Modal can animate into another type. */
export const getModalTransition = (type?: ModalType) => {
  if (type === 'left-panel') return slide(-100, 0)
  if (type === 'right-panel') return slide(100, 0)
  if (type === 'top-panel') return slide(0, -100)
  if (type === 'bottom-panel') return slide(0, 100)

  if (type === 'primary-navbar-more')
    return {
      from: { x: -90, y: 0, scale: 1, opacity: 1 },
      enter: { x: 10, y: 0, scale: 1, opacity: 1 },
      leave: { x: -90, y: 0, scale: 1, opacity: 1 },
    }

  return {
    from: { x: -50, y: -10, scale: 0.8, opacity: 0 },
    enter: { x: -50, y: -50, scale: 1, opacity: 1 },
    leave: { x: -50, y: -50, scale: 0.8, opacity: 0 },
  }
}

export const toTransform = (x: number, y: number, scale: number) =>
  `translate3d(${x}%, ${y}%, 0) scale(${scale})`
